import { Col, Image, Row, Table, Typography } from "antd"
import React from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { FileDoneOutlined, QuestionCircleOutlined } from "@ant-design/icons"
import { useCollection } from "../../../hooks/useCollection"
import moment from "moment/moment"
import useInteractiveTableFilters from "../../../components/Filters/InteractiveFilters"
import TechnicalReqDetails from "./TechnicalReqDetails"

const { Text, Link } = Typography

const filterConfig = [
  { key: "client", dataIndex: "client" },
  { key: "product", dataIndex: ["product", "productName"] },
  { key: "filterGroup", dataIndex: "filterGroup" },
]

export default function TechnicalRequests() {
  const { data, loading } = useCollection("priceCalculation", ["hasTechincalPage", "==", 1])

  const [appliedFilters, setAppliedFilters, generateFilters] = useInteractiveTableFilters(
    data,
    filterConfig
  )

  //Controls the state of columns
  const columns = [
    {
      title: "Clients",
      dataIndex: "client",
      filters: generateFilters("client", "client"),
      onFilter: (value, record) => record.client === value,
      filterSearch: true,
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      filters: generateFilters("product", "productName"),
      filterSearch: true,
      onFilter: (value, record) => record.product.productName === value,
    },
    {
      title: "Width",
      dataIndex: "labelWidth",
      sorter: (a, b) => a.labelWidth - b.labelWidth,
    },
    {
      title: "Height",
      dataIndex: "labelHeight",
      sorter: (a, b) => a.labelHeight - b.labelHeight,
    },
    {
      title: "Machine",
      dataIndex: "machine",
      sorter: (a, b) => a.machine - b.machine,
    },
    {
      title: "Knife",
      dataIndex: "knifeCode",
      sorter: (a, b) => a.knifeCode - b.knifeCode,
    },
    {
      title: "Material",
      dataIndex: "material",
      sorter: (a, b) => a.material - b.material,
    },
    {
      title: "File Attachment",
      align: "center",
      render: (record) => {
        if (record.hasTechnicalFileUrl) {
          return (
            <Link>
              <a href={record.technicalFileUrl} target="_blank" rel="noopener noreferrer" download>
                Download <FileDoneOutlined />
              </a>
            </Link>
          )
        } else {
          return <Text>No File</Text>
        }
      },
    },
    {
      title: "Product Picture",
      align: "center",
      dataIndex: ["product", "productFileUrl"],
      render: (value) => {
        if (value) {
          return (
            <>
              <Image src={value} width={25} />
            </>
          )
        } else {
          return <Text> No image</Text>
        }
      },
    },
    {
      title: "Language",
      align: "center",
      dataIndex: ["technicalLanguage"],
    },
    {
      title: "Details",
      align: "center",
      render: (value) => <TechnicalReqDetails priceData={value} />,
    },

    {
      title: "Created",
      dataIndex: ["date", "created"],
      sorter: (a, b) => a.date.create.seconds - b.date.create.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },
  ]

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader
            appliedFilters={appliedFilters}
            text="Technical page requests"
            icon={<QuestionCircleOutlined />}
          />
        </Col>
        <Col span={24}>
          <Table
            size="small"
            rowKey={(record) => record.id}
            pagination={{ defaultPageSize: "30" }}
            onChange={(pagination, filters) => {
              setAppliedFilters({
                client: filters.client || [],
                product: filters.product || [],
                filterGroup: filters.filterGroup || [],
              })
            }}
            dataSource={data && data}
            loading={loading}
            columns={columns}
          />
        </Col>
      </Row>
    </div>
  )
}
